import {ChangeDetectionStrategy, Component, computed, inject, Signal} from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { LayoutTypes } from '../layout.types';
import { DefaultLayoutComponent } from '../layouts/default-layout/default-layout.component';
import {BlankLayoutComponent} from "../layouts/blank/blank-layout.component";

@Component({
  selector: 'app-layout-selector',
  imports: [DefaultLayoutComponent, BlankLayoutComponent],
  templateUrl: './layout-selector.component.html',
  styleUrl: './layout-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutSelectorComponent {
  protected router: Router = inject(Router);
  protected activeRouteData: Signal<Data | undefined> = toSignal(
    inject(ActivatedRoute).data,
  );
  protected selectedLayout: Signal<LayoutTypes | undefined> = computed(() => {
    const routeData: Data | undefined = this.activeRouteData();
    if (!routeData) {
      return 'default';
    }
    return routeData['layout'];
  });
}
